module.exports = __webpack_public_path__ + "2315d11516637f27aba9227783afa732.svg";